<template lang="html">
  <div class="custom-time-picker">
    <div class="box">
      <div class="custom-time-picker-header">
        已选择每天{{selectHour<10?'0'+selectHour:selectHour}}:{{selectMin<10?'0'+selectMin:selectMin}}接收课程提醒
      </div>
      <div class="custom-time-picker-main">
        <div class="custom-time-picker-container">
          <div class="cover cover-top"></div>
          <div class="cover cover-bottom"></div>
          <div class="cover-active">:</div>
          <div class="custom-time-picker-swiper">
            <swiper :options="swiperHours" ref="hourSwiper">
              <swiper-slide v-for="(item, index) in hours" :key="index">{{item}}时</swiper-slide>
            </swiper>
          </div>
          <div class="custom-time-picker-swiper">
            <swiper :options="swiperMins" ref="minSwiper">
              <swiper-slide v-for="(item, index) in mins" :key="index">{{item}}分</swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="unsubscribe">
      <span>消息推送</span>
      <input
        class="switch switch-anim"
        @change="$emit('changeSwitch')"
        :value="isSubscribe"
        type="checkbox"
        :checked="isSubscribe"/>
    </div>
    <PickerButton
      v-if="isSubscribe"
      class="picker-btn"
      width="370"
      fontSize="36"
      @click="selectTime">立即定制</PickerButton>
    <Notice ref="notice">
      <div class="notice-main">
        <h1>温馨提示</h1>
        <p>亲爱的小主，您取消的不止是课程</p>
        <p>提醒，更是一种学习习惯哦！</p>
        <p> 提醒能让您坚持更长久！</p>
        <div class="notice-buttonGroup">
          <PickerButton width="220" type="gray" @click="closePush">取消推送</PickerButton>
          <PickerButton width="220" @click="$emit('changeSwitch');$refs.notice.close()">保持学习</PickerButton>
        </div>
      </div>
    </Notice>
  </div>
</template>

<script>
  import PickerButton from '../UI/Button'
  import Notice from '../Notice'

  export default {
    name: 'CustomTimePicker',
    data() {
      return {
        selectHour: 1, // 选中的小时
        selectMin: 0, // 选中的分钟
        // isSubscribe: true,
        /*
        * swiper选项 用以控制小时
        * */
        swiperHours: {
          direction: 'vertical',
          centeredSlides: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          initialSlide: 7,
          slidesPerView: 5,
          on: {
            slideChangeTransitionEnd: () => {
              let swiper = this.hourSwiper
              let activeIndex = swiper? swiper.activeIndex : this.swiperHours.initialSlide
              this.selectHour = parseInt(this.hours[activeIndex])
            }
          }
        },
        /*
        * swiper选项 用以控制分钟
        * */
        swiperMins: {
          direction: 'vertical',
          centeredSlides: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          initialSlide: 0,
          slidesPerView: 5,
          on: {
            slideChangeTransitionEnd: () => {
              let activeIndex = this.minSwiper.activeIndex
              this.selectMin = parseInt(this.mins[activeIndex])
            }
          }
        },
      }
    },
    watch: {
      selectHourIndex (val) {
        this.hourSwiper.slideTo(val, 0)
      },
      selectMinIndex (val) {
        this.minSwiper.slideTo(val, 0)
      },
      isSubscribe (val) {
        if (!val) {
          this.$refs.notice.show()
        }
      },
    },
    props: ['hours', 'mins', 'selectMinIndex', 'selectHourIndex', 'switchType', 'switchTypeFlag'],
    methods: {
      selectTime () {
        this.$emit('selectTime', { hour: this.selectHour, min: this.selectMin})
      },
      closePush () {
        if (this.switchTypeFlag) {
          this.$emit('switchPush');
        }
        this.$refs.notice.close()
      }
    },
    computed: {
      hourSwiper () {
        return this.$refs.hourSwiper.swiper
      },
      minSwiper () {
        return this.$refs.minSwiper.swiper
      },
      isSubscribe () {
        return this.switchType
      }
    },
    mounted () {
    },
    components: {
      PickerButton,
      Notice
    }
  }
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .switch {
    width: rem(100);
    height: rem(50);
    position: relative;
    box-sizing: border-box;
    border: 1px solid #ececec;
    background-color: #ececec;
    box-shadow: #ececec 0 0 0 0 inset;
    border-radius: rem(30);
    background-clip: content-box;
    display: inline-block;
    -webkit-appearance: none;
    user-select: none;
    outline: none;
    &:before {
      content: '';
      width: rem(45);
      height: rem(45);
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 100%;
      background-color: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    }
    &:checked {
      border-color: #F69600;
      box-shadow: #F69600 0 0 0 rem(16) inset;
      background-color: #F69600;
      &:before {
        left: rem(48);
      }
    }
    &-anim {
      transition: border cubic-bezier(0, 0, 0, 1) 0.4s, box-shadow cubic-bezier(0, 0, 0, 1) 0.4s;
      &:before {
        transition: left 0.3s;
      }
      &:checked {
        box-shadow: #F69600 0 0 0 rem(16) inset;
        background-color: #F69600;
        transition: border ease 0.4s, box-shadow ease 0.4s, background-color ease 1.2s;
        &:before {
          transition: left 0.3s;
        }
      }
    }
  }
  .unsubscribe {
    width: rem(654);
    height: rem(120);
    font-size: rem(30);
    color: #333333;
    font-weight: bold;
    background-color: #fff;
    margin: rem(30) auto rem(50) auto;
    box-shadow: 0 rem(10) rem(26) 0 #dcdcdc;
    display: flex;
    justify-content: space-between;
    border-radius: rem(10);
    align-items: center;
    padding: 0 rem(20);
    box-sizing: border-box;
  }
  .custom-time-picker {
    .notice-main {
      text-align: center;
      h1 {
        padding: rem(40) 0;
        font-size: rem(36);
        font-weight: bold;
      }
      p {
        font-size: rem(28);
        color: #333;
        line-height: 1.4;
      }
      .notice-buttonGroup {
        padding: rem(50) 0;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
      }
    }
    .box {
      width: rem(650);
      margin: auto;
      text-align: center;
      background: #fff;
      box-shadow: 0 rem(10) rem(26) 0 #dcdcdc;
      border-radius: rem(10);
      overflow: hidden;
    }
    .notice-main {
      text-align: center;
      h1 {
        padding: rem(40) 0;
        font-size: rem(36);
        font-weight: bold;
      }
      p {
        font-size: rem(28);
        color: #333;
        line-height: 1.4;
      }
      .notice-buttonGroup {
        padding: rem(50) 0;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
      }
    }
    .picker-btn {
      text-align: center;
      font-weight: bold;
      margin: auto;
      box-shadow: 0 rem(6) rem(20) 0 #F59300;
    }
    &-header {
      height: rem(80);
      line-height: rem(80);
      font-size: rem(30);
      color: #F46D00;
      font-weight: bold;
      background-color: #FDFDFD;
      border-bottom: rem(2) solid #F6F6F6;
    }

    &-main {
      padding: rem(53) 0;
    }

    &-container {
      width: rem(530);
      height: rem(240);
      overflow: hidden;
      margin: auto;
      display: flex;
      position: relative;
    }

    .cover {
      position: absolute;
      width: 100%;
      height: rem(60);
      z-index: 99;

      &-top {
        top: 0;
        background: linear-gradient(to bottom, #FFF 0, rgba(255, 255, 255, 0) 100%);
      }

      &-bottom {
        bottom: 0;
        background: linear-gradient(to top, #FFF 0, rgba(255, 255, 255, 0) 100%);
      }

      &-active {
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        bottom: rem(60);
        line-height: rem(60);
        background: #FEFAF4;
        border: rem(2) solid #F7EBDA;
        font-size: rem(30);
        color: #F46D00;
        border-radius: rem(50);
      }
    }

    &-swiper {
      width: rem(265);
      height: rem(300);
      font-size: rem(30);
    }

    .swiper-container {
      height: 100%;
    }

    .swiper-slide {
      height: rem(60);
      line-height: rem(60);

      &-active {
        color: #F46D00;
      }
    }
    .notice-main {
      text-align: center;
      h1 {
        padding: rem(40) 0;
        font-size: rem(36);
        font-weight: bold;
      }
      p {
        font-size: rem(28);
        color: #333;
        line-height: 1.4;
      }
      .notice-buttonGroup {
        padding: rem(50) 0;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
      }
    }
    .switch {
      width: rem(100);
      height: rem(50);
      position: relative;
      box-sizing: border-box;
      border: 1px solid #ececec;
      background-color: #ececec;
      box-shadow: #ececec 0 0 0 0 inset;
      border-radius: rem(30);
      background-clip: content-box;
      display: inline-block;
      -webkit-appearance: none;
      user-select: none;
      outline: none;
      &:before {
        content: '';
        width: rem(45);
        height: rem(45);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 100%;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      }
      &:checked {
        border-color: #F69600;
        box-shadow: #F69600 0 0 0 rem(16) inset;
        background-color: #F69600;
        &:before {
          left: rem(48);
        }
      }
      &-anim {
        transition: border cubic-bezier(0, 0, 0, 1) 0.4s, box-shadow cubic-bezier(0, 0, 0, 1) 0.4s;
        &:before {
          transition: left 0.3s;
        }
        &:checked {
          box-shadow: #F69600 0 0 0 rem(16) inset;
          background-color: #F69600;
          transition: border ease 0.4s, box-shadow ease 0.4s, background-color ease 1.2s;
          &:before {
            transition: left 0.3s;
          }
        }
      }
    }
    .unsubscribe {
      width: rem(654);
      height: rem(120);
      font-size: rem(30);
      color: #333333;
      font-weight: bold;
      background-color: #fff;
      margin: rem(30) auto rem(50) auto;
      box-shadow: 0 rem(10) rem(26) 0 #dcdcdc;
      display: flex;
      justify-content: space-between;
      border-radius: rem(10);
      align-items: center;
      padding: 0 rem(20);
      box-sizing: border-box;
    }
  }

</style>
